import React from 'react';

import { Link } from 'react-router-dom';

function WhatIsAlignmentDeclaration() {
  return (
    <>

      <div className="bg-[#F9FAFB] min-h-screen font-sans">
        <div className="bg-white border-b border-gray-200">
          <div className="max-w-4xl mx-auto px-6 py-16">
            <h1 className="text-3xl md:text-4xl font-bold text-[#102A43] mb-6">Accountability Declaration</h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              A public commitment to baseline principles for emerging operators.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-6 py-12 space-y-12">
          
          {/* What This Is */}
          <section className="bg-white p-8 rounded-sm shadow-sm border border-gray-200">
            <h2 className="text-2xl font-bold text-[#102A43] mb-6 border-b border-gray-100 pb-4">What This Is</h2>
            <div className="space-y-4 text-[#64748B] leading-relaxed">
              <p>
                The <strong>Accountability Declaration</strong> is a mechanism for individuals and smaller teams to publicly commit to AASC baseline principles. 
              </p>
              <p>
                It is <strong>not declaration</strong>. It is a self-attested declaration that you understand the standards and apply them in your work. It allows early-stage operators to signal professional intent before they are ready for the rigor of full organizational declaration.
              </p>
            </div>
          </section>

          {/* Who This Is For */}
          <section>
            <h2 className="text-2xl font-bold text-[#102A43] mb-6">Who This Is For</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {['Freelancers', 'Early-Stage Operators', 'Educators', 'Small Teams', 'Non-Production Experiments'].map((item) => (
                <div key={item} className="bg-green-50 border border-green-100 p-4 rounded-sm text-green-900 font-medium">
                  {item}
                </div>
              ))}
            </div>
          </section>

          {/* What You Declare */}
          <section className="bg-white p-8 rounded-sm shadow-sm border border-gray-200">
            <h2 className="text-2xl font-bold text-[#102A43] mb-6">What You Declare</h2>
            <ul className="space-y-4 text-[#64748B]">
              <li className="flex items-start gap-3">
                <span className="text-green-600 font-bold">✓</span>
                I understand the AASC baseline principles for accountability and human oversight.
              </li>
              <li className="flex items-start gap-3">
                <span className="text-green-600 font-bold">✓</span>
                I commit to applying these principles in my work to the best of my ability.
              </li>
              <li className="flex items-start gap-3">
                <span className="text-green-600 font-bold">✓</span>
                I will disclose my status accurately to clients/employers.
              </li>
              <li className="flex items-start gap-3">
                <span className="text-green-600 font-bold">✓</span>
                I will NOT misrepresent this declaration as a full declaration.
              </li>
            </ul>
          </section>

          {/* Registry Listing */}
          <section>
            <h2 className="text-2xl font-bold text-[#102A43] mb-6">Registry Listing & Badging</h2>
            <p className="text-[#64748B] mb-4">
              Declarants are listed in a separate section of the public AASC Registry. You will receive:
            </p>
            <ul className="list-disc pl-5 space-y-2 text-[#64748B] mb-6">
              <li>A verifiable profile page on the registry.</li>
              <li>A "Standards Alignment Declarant" digital badge for your website.</li>
              <li>A unique verification ID.</li>
            </ul>
            <div className="bg-gray-100 p-4 text-sm text-gray-600 italic">
              Note: The badge is distinct from the "Declared Organization" seal to ensure clarity in the market.
            </div>
          </section>

          {/* Renewal */}
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4">Renewal and Expiration</h2>
            <p className="text-[#64748B]">
              Declarations are valid for <strong>12 months</strong>. You must renew your commitment annually to maintain active status in the registry.
            </p>
          </section>

          {/* Important Clarification */}
          <section className="bg-yellow-50 border-l-4 border-yellow-400 p-6">
            <h2 className="text-xl font-bold text-yellow-900 mb-3">Important Clarification</h2>
            <p className="text-yellow-800 leading-relaxed">
              This is <strong>NOT declaration</strong>. It does not involve a review of your evidence artifacts. It is a professional commitment. Misrepresenting a Declaration as "declaration" is a violation of the terms and will result in immediate removal from the registry and a permanent ban.
            </p>
          </section>

          <div className="flex justify-center pt-8">
            <Link to="/declare-alignment" className="px-8 py-4 bg-[#2F80ED] text-white font-bold rounded-sm hover:bg-[#2563eb] transition-colors">
              Make Your Declaration
            </Link>
          </div>

        </div>
      </div>
    </>
  );
}

export default WhatIsAlignmentDeclaration;